import { render } from "./BlogComp.vue?vue&type=template&id=db07136e&scoped=true&ts=true"
import script from "./BlogComp.vue?vue&type=script&lang=ts"
export * from "./BlogComp.vue?vue&type=script&lang=ts"

import "./BlogComp.vue?vue&type=style&index=0&id=db07136e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db07136e"]])

export default __exports__